import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles(({ typographyPresets, colors }) => ({
    note: {
        ...typographyPresets.bodyPrimary,
        fontSize: '20px',
        cursor: 'pointer',
        backgroundImage: 'linear-gradient(to top, rgb(43,48,57), rgb(50,55,66))',
        color: colors.white,
        minHeight: '100px',
        padding: '20px',
        marginBottom: '20px',
        whiteSpace: 'pre-wrap',
        overflowWrap: 'break-word',
    },
}))
